import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import defaultContextTypes from '../../../../../../../src/components/default-context-types';
import FlightPositionalInformationContainer from './FlightPositionalInformation/container';
import componentBase from '../../../../../../../src/lib/component-base';

const isLoading = s => s.Account.loading || s.SingleFlightTracker.loading ||
  s.MultiFlightTracker.loading || s.AirportDeparturesArrivals.loading ||
  s.AirportCurrentConditions.loading || s.AirportDelayMap.loading ||
  s.SingleHistoricalFlightStatus.loading || s.MultiHistoricalFlightStatus.loading;

@connect(state => ({
  userAgent: state.App.userAgent,
  user: state.Account.user,
  loggedIn: state.Account.loggedIn,
  isLoading: isLoading(state),
}))
@componentBase('FlightMapContainer')
class FlightMapContainer extends Component {
  static propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    flight: PropTypes.object,
    params: PropTypes.object,
    user: PropTypes.object,
    isLoading: PropTypes.bool,
    setSessionItem: PropTypes.func,
    userAgent: PropTypes.object,
    loggedIn: PropTypes.bool,
  };

  static childContextTypes = defaultContextTypes;

  gotoHandler = (path, button) => () => this.goto(path, button);

  goto = (path, button) => {
    this.context.store.dispatch(push(path));

    if (button) {
      this.reportButtonPress(button);
    }
  }

  render() {
    const curtainStyle = {
      zIndex: 1090,
      position: 'fixed',
      overflow: 'show',
      margin: 'auto',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    };

    const spinner = (
      <div style={curtainStyle} className='spinner'>
        <div className='rect1' />
        <div className='rect2' />
        <div className='rect3' />
        <div className='rect4' />
        <div className='rect5' />
      </div>
    );

    return (
      <div style={{ height: '100%' }}>
        {this.props.isLoading ? spinner : null}
        <div style={{ width: '100%', height: '100%' }}>
          <FlightPositionalInformationContainer
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

export default FlightMapContainer;



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightPositionalInformationSection/children/FlightMapContainer.js